import SupportCase from 'api/support-case.types';
import { ChevronIcon } from 'assets/icons';
import { Card } from 'components/Card';
import { Loader } from 'components/Loader';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ContentUtil } from 'utils';
import { DateFormat, dateUtils } from 'utils/date';

import formatSupportCaseStatusUtil from '../../utils/formatSupportCaseStatus';
import content from './support-case-overview.content';
import * as Styles from './support-case-overview.styles';

const contentUtil = new ContentUtil({ content, componentName: 'SupportCaseOverview' });

interface ISupportCaseTableArguments {
  isLoading: boolean;
  supportCases: Array<SupportCase>;
}

const SupportCaseLayout = (args: ISupportCaseTableArguments) => {
  const navigate = useNavigate();

  const navigateToDetailPage = (reference: string) => {
    if (reference) {
      navigate(`/service/case/${reference}`);
    }
  };

  if (args.isLoading) {
    return <Loader />;
  }

  if (args.supportCases.length === 0) {
    return <Styles.NoContent>{contentUtil.translateToString('card.noContent')}</Styles.NoContent>;
  }

  return (
    <Styles.CardsContainer>
      {args.supportCases.map((supportCase) => (
        <Card
          key={supportCase.reference}
          data-testid={`support-case-card-${supportCase.reference}`}
          contentPadding={[1.5, 1.5, 1.5, 1.5]}>
          <Styles.CardHeader>
            <Styles.CaseTitle>{supportCase.title}</Styles.CaseTitle>
            <Styles.StatusBadge status={supportCase.status}>
              {formatSupportCaseStatusUtil(supportCase.status)}
            </Styles.StatusBadge>
          </Styles.CardHeader>
          <Styles.CardContent>
            <Styles.InfoRow>
              <span>{contentUtil.translateToString('card.headings.reference')}:</span>
              <span>{supportCase.reference}</span>
            </Styles.InfoRow>
            <Styles.InfoRow>
              <span>{contentUtil.translateToString('card.headings.date')}:</span>
              <span>{dateUtils.format(supportCase.date, DateFormat.DATE)}</span>
            </Styles.InfoRow>
          </Styles.CardContent>
          <Styles.DetailsButton
            variant="text-only"
            iconAfter={<ChevronIcon />}
            onClick={() => navigateToDetailPage(supportCase.reference)}>
            {contentUtil.translateToString('card.viewDetails')}
          </Styles.DetailsButton>
        </Card>
      ))}
    </Styles.CardsContainer>
  );
};

export default SupportCaseLayout;
